export default __webpack_public_path__ + "static/media/n4.2750ddbd.jpg";